import Node from './Node';
import BinaryNode from './BinaryNode';
import TextType from './TextType';

export default class DivisionNode extends BinaryNode {

	protected create (left: Node, right: Node) {
		return new DivisionNode(left, right);
	}

	protected getTextPrefix (textType = TextType.PLAIN) {
		switch (textType) {
			case TextType.LATEX:
				return '(\\frac{';
			case TextType.LATEX_PHYSICAL_UNIT:
				return '';
			default:
				return '(';
		}
	}

	protected getTextInfix (textType = TextType.PLAIN) {
		switch (textType) {
			case TextType.LATEX:
				return '}{';
			case TextType.LATEX_PHYSICAL_UNIT:
				return '//';
			default:
				return ' / ';
		}
	}

	protected getTextPostfix (textType = TextType.PLAIN) {
		switch (textType) {
			case TextType.LATEX:
				return '})';
			case TextType.LATEX_PHYSICAL_UNIT:
				return '';
			default:
				return ')';
		}
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/parsing/nodes/DivisionNode.ts